module.exports = __webpack_public_path__ + "media/images/icon__externalLink@2x-f0e9419d5f55e75e8c7c28d2cb651eb0.png";